import { connect } from 'react-redux'
import { setArea } from '../../core/actions'
import { toggleNodes } from '../../selection/actions'
import {
  getNodeById,
  getChildNodesById,
} from '../../core/selectors'
import { getNodeSelectionById } from '../../selection/selectors'
import HouseTypeDetail from '../components/houseTypeDetail'

const mapStateToProps = (state, ownProps) => ({
  houseType: getNodeById({
    state,
    id: ownProps.match.params.id,
  }),
  layouts: getChildNodesById({
    state,
    id: ownProps.match.params.id,
  }),
  parentSelection: getNodeSelectionById({
    state,
    id: ownProps.match.params.id,
  }),
})

const mapDispatchToProps = dispatch => ({
  handleClick: (node) => {
    dispatch(toggleNodes(node))
    if (node.area) {
      dispatch(setArea(node.area))
    }
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HouseTypeDetail)



// WEBPACK FOOTER //
// ./src/modules/houseType/containers/houseTypeDetail.js